'use client';

import { Fragment } from 'react';
import styles from './SectionTitle.module.scss';

export interface SectionTitleProps {
  eyebrow?: string;
  title?: string;
  description?: string;
  points?: Array<{ pain: string; solution: string; anchor?: string }>;
}

const renderTitle = (title: string) => {
  const parts = title.split('*');
  return parts.map((part, i) => {
    if (i % 2 === 1) {
      return <em key={i}>{part}</em>;
    }
    const segments = part.split('—');
    return segments.map((segment, j) => (
      <Fragment key={j}>
        {segment}
        {j < segments.length - 1 && <span className={styles.titleDash}>—</span>}
      </Fragment>
    ));
  });
};

export const SectionTitle = ({
  eyebrow = 'Ce qui nous différencie',
  title = 'Une équipe dédiée, une méthode *éprouvée*, un résultat *garanti*.',
  description,
  points,
}: SectionTitleProps) => {
  return (
    <section className={styles.section} aria-labelledby="section-title">
      <div className={styles.content}>
        {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
        <h2 id="section-title" className={styles.title}>
          {renderTitle(title)}
        </h2>
        {description && <p className={styles.description}>{description}</p>}

        {points && points.length > 0 && (
          <div className={styles.points}>
            {points.map((point, i) => {
              const CardWrapper = point.anchor ? 'a' : 'div';
              const cardProps = point.anchor
                ? { href: `#${point.anchor}`, className: styles.pointCardLink }
                : { className: styles.pointCard };
              return (
                <CardWrapper key={i} {...cardProps}>
                  <span className={styles.pointNumber}>{String(i + 1).padStart(2, '0')}</span>
                  <p className={styles.pointPain}>{point.pain}</p>
                  <p className={styles.pointSolution}>{point.solution}</p>
                </CardWrapper>
              );
            })}
          </div>
        )}

        <span className={styles.divider} aria-hidden="true" />
      </div>
    </section>
  );
};
